import { Buffer } from 'buffer';

export const readStream = async (reader) => {
    try{
      var chunks = [];
      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          var result = Buffer.concat(chunks);
          console.log('final result:', result.length);
          return result.toString('base64')
        }
        chunks.push(value);
        
      }
    } catch (error) {
      console.error('error on reading stream', error);
    }
  }